import { fields, orderingAndLimit } from "./variables"
import { groqFeed } from "./feed"

export const groqTermFeed = (type: string, slug: string) => {
  const { filter } = groqFeed("opportunities")

  const subQuery = `*[_type == '${type}' && slug.current == '${slug}'][0]`
  const termFilter = `${filter} && references(${subQuery}._id)`

  const { getFirstPage, getNextPage } = queries(
    termFilter,
    orderingAndLimit,
    fields,
  )

  const getTermBySlug = () => groq`${subQuery}`

  return {
    getFirstPage,
    getNextPage,
    getTermBySlug,
  }
}
